import { render, staticRenderFns } from "./FacIndex.vue?vue&type=template&id=2ef4be5a"
import script from "./FacIndex.vue?vue&type=script&lang=js"
export * from "./FacIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports